
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const LoadingTopicDisplay = () => (
    <Card className="dark:bg-stone-800 dark:border-stone-700">
        <CardHeader>
            <Skeleton className="h-8 w-64 dark:bg-stone-700" />
        </CardHeader>
        <CardContent className="space-y-4">
            <Skeleton className="h-4 w-full dark:bg-stone-700" />
            <Skeleton className="h-4 w-3/4 dark:bg-stone-700" />
            <Skeleton className="h-4 w-5/6 dark:bg-stone-700" />
        </CardContent>
    </Card>
);
